/**
 * Erreurs liées aux positionnements (Positioning)
 */

import { ERROR_CODES } from '@repo/contracts/errors';

import { ErrorConfigWithCallback } from './types';

export const POSITIONING_ERRORS: Record<string, ErrorConfigWithCallback> = {
    [ERROR_CODES.POSITIONING_NOT_FOUND]: {
        messageKey: 'no-positioning-was-found-for-this-entity-and-opportunity',
        severity: 'error',
    },
    [ERROR_CODES.REFUSAL_POSITIONING_STATE_NOT_CONFIGURED]: {
        messageKey: 'the-refusal-positioning-state-is-not-configured-in-neylia-settings',
        severity: 'error',
    },
};
